module.exports = require("core-js/library/fn/number/is-nan");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/number/is-nan.js
// module id = 115
// module chunks = 35783957827783 114276838955818 162898551421021